import React, {useEffect, useState} from "react";
import {Form, FormGroup, FormControl, Col, ControlLabel, Button, Modal, HelpBlock} from "react-bootstrap";
import "./style.less";
import {login, logout, requestLoginPassword} from "api";

export const LoginPage = ({onSuccess}) => {
    const [emailRequesting, setEmailRequesting] = useState(false);
    const [passwordRequesting, setPasswordRequesting] = useState(false);
    const [passwordRequested, setPasswordRequested] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState(null);
    const [passwordError, setPasswordError] = useState(null);

    useEffect(() => {
        if (!emailError) {
            return;
        }

        setTimeout(() => setEmailError(null), 3000);
    }, [emailError]);
    useEffect(() => {
        if (!passwordError) {
            return;
        }

        setTimeout(() => setPasswordError(null), 3000);
    }, [passwordError]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (passwordRequested) {
            setPasswordRequesting(true);
            try {
                let user = await login(email, password);
                onSuccess(user);
            } catch (e) {
                setPasswordError(e.error.message);
            }
            setPasswordRequesting(false);
        } else {
            setEmailRequesting(true);
            try {
                await requestLoginPassword(email);
                setPasswordRequested(true);
            } catch (e) {
                setEmailError(e.error.message);
            }
            setEmailRequesting(false);
        }
    }

    return (
        <div className="login-form">
            <Form horizontal onSubmit={handleSubmit}>
                <Modal.Dialog>
                    <Modal.Body>
                        <FormGroup validationState={emailError ? 'error' : null}>
                            <Col componentClass={ControlLabel} sm={2}>eMail</Col>
                            <Col sm={10}>
                                <FormControl
                                    name="email"
                                    type="email"
                                    placeholder="user@comdi.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    readOnly={passwordRequested || emailError}
                                />
                                {!passwordRequested && <HelpBlock>{emailError || <span>&nbsp;</span>}</HelpBlock>}
                            </Col>
                        </FormGroup>

                        {passwordRequested && <FormGroup validationState={passwordError ? 'error' : null}>
                            <Col componentClass={ControlLabel} sm={2}>Пароль</Col>
                            <Col sm={10}>
                                <FormControl
                                    name="password"
                                    type="password"
                                    placeholder="Пароль"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    readOnly={passwordError}
                                />
                                <HelpBlock>
                                    {passwordError || `Одноразовый пароль был отправлен на указанную почту`}
                                </HelpBlock>
                            </Col>
                        </FormGroup>}
                    </Modal.Body>

                    <Modal.Footer>
                        {passwordRequested ?
                            <Button type="submit" bsStyle="primary" disabled={!!(passwordError || passwordRequesting)}>
                                Войти
                            </Button>
                            :
                            <Button type="submit" bsStyle="primary" disabled={!!(emailError || emailRequesting)}>
                                Получить пароль
                            </Button>
                        }
                    </Modal.Footer>
                </Modal.Dialog>
            </Form>
        </div>
    );
};

export const LogoutPage = ({onSuccess, children}) => {
    const [process, setProcess] = useState(true);

    useEffect(() => {
        logout()
            .then(() => {
                onSuccess();
                setProcess(true);
            })
        ;
    }, []);

    if (process) {
        return (
            <div>Logout...</div>
        );
    }

    return children;
};
